import { render, staticRenderFns } from "./RoomTag.vue?vue&type=template&id=1ca646cc&scoped=true&"
import script from "./RoomTag.vue?vue&type=script&lang=js&"
export * from "./RoomTag.vue?vue&type=script&lang=js&"
import style0 from "./RoomTag.vue?vue&type=style&index=0&id=1ca646cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca646cc",
  null
  
)

export default component.exports